import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { EVENTO_CREDENCIAL_EXPIRADA, estaNaAreaAdministrativa } from '../features/credencialPublica';
import ModuloAdministrativo from './ModuloAdministrativo.jsx';
import PageIdentificacao from './publica/Page/PageIdentificacao.jsx';
import PageInscricaoNova from './publica/Page/PageInscricaoNova.jsx';
import PageInscricaoExistente from './publica/Page/PageInscricaoExistente.jsx';
import { ToastProvider } from './shared/toast/ToastProvider.tsx';
import ConfirmationDialogProvider from './shared/confirmationdialog/ConfirmationDialogProvider.js';
import DownloadSegundoPlanoProvider from './shared/downloadsegundoplano/DownloadSegundoPlanoProvider.jsx';

/* Vai para a identificação mantendo a query (o link do processo seletivo traz ?p=ID). */
function RedirecionarIdentificacao() {
    const location = useLocation();
    return <Navigate to={`/publico/identificacao${location.search}`} replace />;
}

export default function WrappedRoutes() {
    const navigate = useNavigate();

    /*
     * Credencial vencida ou recusada (401): a mensagem do back já aparece no erro da chamada; na área pública
     * volta para a identificação. No administrativo fica na tela: a credencial nova vem do portal.
     */
    useEffect(() => {
        const aoExpirar = () => {
            if (!estaNaAreaAdministrativa()) {
                navigate('/publico/identificacao', { replace: true });
            }
        };
        window.addEventListener(EVENTO_CREDENCIAL_EXPIRADA, aoExpirar);
        return () => window.removeEventListener(EVENTO_CREDENCIAL_EXPIRADA, aoExpirar);
    }, [navigate]);

    const handleIdentificacaoProximo = (response) => {
        if (response.inscrito) {
            // Se já for inscrito, navega para a visualização da inscrição existente
            navigate('/publico/inscricao-existente', { state: { identificacao: response } });
        } else {
            // Se for uma inscrição nova, navega para a página de nova inscrição
            navigate('/publico/inscricao-nova', { state: { identificacao: response } });
        }
    };

    return (
        <ToastProvider>
            <ConfirmationDialogProvider>
                <DownloadSegundoPlanoProvider>
                    <Routes>
                        {/* A apresentação foi removida: a entrada do público é a identificação. */}
                        <Route path='/' element={<RedirecionarIdentificacao />} />
                        <Route path='/publico' element={<RedirecionarIdentificacao />} />
                        <Route path='/publico/identificacao' element={<PageIdentificacao onProximo={handleIdentificacaoProximo} />} />
                        <Route path='/publico/inscricao-nova' element={<PageInscricaoNova />} />
                        <Route path='/publico/inscricao-existente' element={<PageInscricaoExistente />} />
                        <Route path='/administrativo/*' element={<ModuloAdministrativo />} />
                    </Routes>
                </DownloadSegundoPlanoProvider>
            </ConfirmationDialogProvider>
        </ToastProvider>
    );
}


